import { render, staticRenderFns } from "./BasePreviewFotoFacial.vue?vue&type=template&id=35bea6bf&scoped=true"
import script from "./BasePreviewFotoFacial.vue?vue&type=script&lang=js"
export * from "./BasePreviewFotoFacial.vue?vue&type=script&lang=js"
import style0 from "./BasePreviewFotoFacial.vue?vue&type=style&index=0&id=35bea6bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bea6bf",
  null
  
)

export default component.exports